import "./Header.scss";
import React from "react";
import logo from "../../assets/images/logo_one.svg";
import logbook from "../../assets/images/Logbook.svg";
import reports from "../../assets/images/Report.svg";
import training from "../../assets/images/Training.svg";
import profile from "../../assets/images/Profile.svg";
import { useAppDispatch } from "../../hooks/app";
import { useSelector } from "react-redux";
import { getActiveTab, getAllTabs, setActiveTab } from "../../store/slices/layout-slice";
import { MAIN_TABS } from "../../constants";
import { useNavigate } from 'react-router-dom';
import { getUser, logoutUser } from "../../store/slices/auth-slice";
import { FiBell } from "react-icons/fi";
import { NavDropdown } from 'react-bootstrap';
import NotificationDropdown from "../Training/dropdown/NotificationDrowdown";
import useComponentVisible from "../../hooks/useComponentVisible";
import { IoMdArrowDropdown } from "react-icons/io";

function Header() {
  const dispatch = useAppDispatch();
  const allTabs = useSelector(getAllTabs);
  const activeTab = useSelector(getActiveTab);
  const currentUser = useSelector(getUser)
  const navigate = useNavigate();
  const [admin, setAdmin] = React.useState(false);
  const [showHeader, setShowHeader] = React.useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const setTab = (tab: string) => {
    dispatch(setActiveTab(allTabs.find((t: any) => t.value === tab)));
  };

  React.useEffect(() => {
    const currentPathname = window.location.pathname;
    if (currentPathname.includes('/admin')) {
      setAdmin(false);
      setShowHeader(true)
      setTab(MAIN_TABS.ADMIN)
      console.log('Admin functionality triggered!');
    }
    else if (currentPathname.includes('/forbidden')) {
      setShowHeader(false)
      setTab(MAIN_TABS.FORBIDDEN)
    }
    else {
      setShowHeader(true)
      setAdmin(true);
      setTab(MAIN_TABS.TRAINING)
      console.log('Client functionality triggered!');
    }
  }, [admin]);


  const handleLogout = () => {
    dispatch(logoutUser(null))
    navigate('/login');
  };
  return (
    <div>
      {showHeader && <nav className="header">
        <div className="left">
          <img src={logo} className="logo" alt="Pilot Logbook Logo" />
          {admin &&
            <div className="tab_box">
              <button className="btn tab_item" style={{ borderColor: activeTab?.value === MAIN_TABS.LOG_BOOK ? "#00af80" : "transparent" }}>
                <img src={logbook} alt="Logbook Logo" />
                <span onClick={() => {
                  setTab(MAIN_TABS.LOG_BOOK)
                  navigate("/")
                }}>Logbook</span>
              </button>
              <button className="btn tab_item" style={{ borderColor: activeTab?.value === MAIN_TABS.REPORTS ? "#00af80" : "transparent" }}>
                <img src={reports} alt="Reports Logo" />
                <span style={{ color: "black", textDecoration: "none" }} onClick={() => {
                  setTab(MAIN_TABS.REPORTS)
                  navigate("/reports")
                }}>Reports</span>
              </button>
              <button className="btn tab_item" style={{ borderColor: activeTab?.value === MAIN_TABS.TRAINING ? "#00af80" : "transparent" }}>
                <img src={training} alt="Training Logo" />
                <span onClick={() => {
                  setTab(MAIN_TABS.TRAINING)
                  navigate("/training/endorsement")
                }}>Training</span>
              </button>
              <button className="btn tab_item" style={{ borderColor: activeTab?.value === MAIN_TABS.PROFILE ? "#00af80" : "transparent" }}>
                <img src={profile} alt="Profile Logo" />
                <span onClick={() => {
                  setTab(MAIN_TABS.PROFILE)
                  navigate("/profile")
                }}>Profile</span>
              </button>
            </div>
          }
        </div>
        <div className="right">
          {admin && <>
            {/* <span className="icon"><FiHelpCircle /></span> */}
            <span className="icon bell_icon" ref={ref} onClick={() => setIsComponentVisible(true)}>
              <FiBell />
              {isComponentVisible && <NotificationDropdown />}
            </span></>}
          <div className="avatar">{currentUser?.firstname?.charAt(0)}{currentUser?.lastname?.charAt(0)}</div>
          <div className="name"></div>

          <NavDropdown
            title={<>{currentUser?.firstname || ""} {currentUser?.lastname || ""}{<IoMdArrowDropdown style={{ fontSize: "20px" }} />}</>}
            className="nav__title"
            menuVariant="light">
            {admin && <><NavDropdown.Item onClick={() => {
              setTab(MAIN_TABS.PROFILE)
              navigate("/profile")
            }}>
              Profile
            </NavDropdown.Item>
            </>}
            <NavDropdown.Item role="button" onClick={() => handleLogout()}>
              Logout
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      </nav>}
    </div>
  );
}

export default Header;
